import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-reports-layout',
  templateUrl: './reports-layout.component.html',
  styleUrls: ['./reports-layout.component.css']
})
export class ReportsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
